<template>
    <div class="captcha" >
        <div class="loading" v-if="!isReady">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
        <div :id="ActiveCaptcha" ></div>
    </div>
</template>
<script>

    export default{
        name:'Captcha',
        data() {
            return {
                isReady: false,
                currentStatus : this.reSent,
                isDestroy :false
            }
        },
        props: {
            width:{
                default:"290px"
            },
            reSent: {
                type: Boolean
            },
            email :{
                default :'',
                type: String
            },
            CaptchaId:{
                default:''
            },
            lang:{
                default: 'zh'
            },
            captchaDestory:{
                type: Boolean,
                default: false
            },
            app_id: {
                type: String,
                default: '55c86e822ef5984cc0b03a3bbfd1a7c7'
            },
            pre_init: {
                type: Boolean,
                default: true
            },
            init: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ActiveCaptcha () {
                return this.CaptchaId
            }
        },
        methods: {
            InitGeetestCap(){
                let that = this;
                if (that.isDestroy) {
                    return;
                    }
                    initGeetest4({
                    // 省略配置参数
                    captchaId: that.app_id,
                    product: 'float',
                    nativeButton: { width: that.width || '290px' },
                    language: that.lang
                }, function (captchaObj) {
                    window.captchaObj = captchaObj
                    captchaObj.appendTo('#'+that.CaptchaId);
                    captchaObj.onNextReady(function () {
                        that.isReady = true;
                    })
                    let ele = that;
                    captchaObj.onSuccess(function () {
                        ele.captchaPass = captchaObj.getValidate();
                        ele.currentStatus = false;
                        ele.$emit('reSentEvent',ele.captchaPass,ele.currentStatus)
                    });

                    });
            },
        },
        mounted() {
           !window.captchaObj && this.pre_init &&  this.InitGeetestCap()  
        },
        watch:{
            reSent(val) {
                if(val){
                    window.captchaObj &&  window.captchaObj.reset()
                }
            },
            init (val) {
                //初始化事件 ，当部署页面不是在页面上直接展示，初始化无法获取验证码dom时， 提供方法重新初始化避免报错
                if (val) {
                    !window.captchaObj && !this.pre_init &&  this.InitGeetestCap()  
                }
            }
            
        },
        components: {},
        destroyed () {
            this.isDestroy = true
            window.captchaObj = null
        }
    }


</script>

<style scoped lang=less rel="stylesheet/less">
    .loading {
        width: 290px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f4f4f4;
        div {
            width: 10px;
            height: 10px;
            background-color: #347EFF;
            border-radius: 50%;
            display: inline-block;
            animation: bounceDelay 1s infinite ease-in-out;
            /* Prevent first frame from flickering when animation starts */
            animation-fill-mode: both;
            margin-left: 4px;
            &.bounce1 {
                animation-delay: -0.32s;
            }
            &.bounce2 {
                animation-delay: -0.16s;
            }
        }
        @keyframes bounceDelay {
            0%, 80%, 100% {
                transform: scale(0);
            }
            40% {
                transform: scale(1.0);
            }
        }
    }
</style>




// WEBPACK FOOTER //
// captcha.vue?44afbb83